import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import { getStrapiMedia } from "../../../utils/utils";
import "./Slider.scss";

import { SliderComponent_Plain } from "../../../types/components/shared/SliderComponent.ts";

const Slider = ({ data }: { data: SliderComponent_Plain[] }) => {
  const swiperRef = useRef(null);
  /*const tabs = data.map((item: SliderComponent_Plain, i: number) => (
    <a className="main-slider__tags-item" key={i} href={item.id}>
      {item.name}
    </a>
  ));*/

  const slides = data.map((item: SliderComponent_Plain, i: number) => (
    <SwiperSlide key={i} className="slider__item">
      {item.image ? (
        <img src={getStrapiMedia(item.image.url)} alt={item.title} />
      ) : (
        ""
      )}
      <div className="slider__text">
        <div className="slider__title">
          <div className="wrapper">{item.title}</div>
        </div>
        <div className="slider__subtitle">
          <div className="slider__subtitle-text">{item.description}</div>
        </div>
      </div>
    </SwiperSlide>
  ));

  const handleScrollToDocuments = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    event.preventDefault();
    const documentsSection = document.querySelector(".documents");
    if (documentsSection) {
      documentsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="main-slider main-slider__regulatory">
      {/*<div className="main-slider__tags">{tabs}</div>*/}
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, EffectFade]}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        effect="fade"
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        onSwiper={(swiper) => {
          console.log("Swiper initialized", swiper);
        }}
        onSlideChange={(swiper) => {
          console.log("Slide changed", swiper.activeIndex);
        }}
        className="slider"
      >
        {slides}
      </Swiper>
      <a
        href="#"
        className="btn-contact btn-contact_small"
        onClick={handleScrollToDocuments}
      >
        See regulatory documents
      </a>
    </section>
  );
};

export default Slider;
